var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.504,
    height: 29.602,
    viewBox: "0 0 23.504 29.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rar",
    transform: "translate(-1.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.239,26.959A2.646,2.646,0,0,1,73.591,29.6H55.383a2.646,2.646,0,0,1-2.648-2.643V2.643A2.646,2.646,0,0,1,55.383,0H66.718a1.988,1.988,0,0,1,1.406.582l7.535,7.536a1.98,1.98,0,0,1,.58,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#fb9225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.357,11.62h-6.729a1.791,1.791,0,0,1-1.79-1.791V3.1a1.967,1.967,0,0,1,.582.4l7.535,7.536a1.967,1.967,0,0,1,.4.581Z",
    transform: "translate(-292.751 -2.922)",
    fill: "#fd6720"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15225",
    "data-name": "Group 15225",
    transform: "translate(6.065 14.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13592",
    "data-name": "Path 13592",
    d: "M87.515,229.112v1.842H86.147v-5.062h1.659q2.064,0,2.063,1.5a1.5,1.5,0,0,1-.859,1.361l1.475,2.206H88.934l-1.074-1.842Zm0-1.029h.256q.717,0,.717-.633,0-.522-.7-.522h-.27Z",
    transform: "translate(-86.147 -225.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13593",
    "data-name": "Path 13593",
    d: "M130.1,230.778l-.249-.948h-1.645l-.256.948h-1.5L128.1,225.7h1.827l1.672,5.083Zm-.533-2.07-.218-.831q-.076-.277-.185-.717t-.144-.63q-.031.174-.123.581t-.407,1.6h1.076Z",
    transform: "translate(-122.196 -225.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13594",
    "data-name": "Path 13594",
    d: "M181.8,229.112v1.842h-1.368v-5.062h1.659q2.063,0,2.063,1.5a1.5,1.5,0,0,1-.859,1.361l1.475,2.206h-1.551l-1.074-1.842Zm0-1.029h.256q.717,0,.717-.633,0-.522-.7-.522h-.27Z",
    transform: "translate(-170.485 -225.871)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.bd318b2ac72f5e1650ef111c2da8b4f7.svg";
export { ForwardRef as ReactComponent };